import React from "react";
import { MobileProjectEntry } from "./contentCards/mobileProjectEntry";
import { projects } from "../../data";

const MobileProjects = () => {
  return (
    <div className="text-white">
      <div
        style={{
          fontSize: "3em",
          fontWeight: "300",
          lineHeight: "1.25",
        }}
        className="py-2"
      >
        Projects
      </div>
      {projects.map((project) => (
        <MobileProjectEntry key={project.id} project={project} />
      ))}
    </div>
  );
};

export default MobileProjects;
